var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{ref:"button",staticClass:"is-answer-option w-100 h-100",attrs:{"variant":_vm.buttonVariant},on:{"click":function($event){$event.preventDefault();return _vm.clickButton.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.teamAnswerOption.answer)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }